<template>
  <div class="grid grid-cols-2 gap-4 max-md:grid-cols-1">
    <div v-for="i in 6" :key="i" class="bg-white border border-black/6 rounded-[20px] p-6 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
      <div class="flex items-center gap-3 mb-5">
        <skeleton width="40px" height="40px" rounded="50%" class-name="shrink-0"></skeleton>
        <div>
          <skeleton width="100px" height="15px" rounded="4px" class-name="mb-1.5"></skeleton>
          <skeleton width="140px" height="12px" rounded="4px"></skeleton>
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <div v-for="j in (i % 2 === 0 ? 3 : 2)" :key="j" class="flex items-center gap-2.5 py-2 px-2.5">
          <skeleton width="28px" height="28px" rounded="50%" class-name="shrink-0"></skeleton>
          <div class="flex-1">
            <skeleton width="90px" height="13px" rounded="4px" class-name="mb-1.5"></skeleton>
            <skeleton width="100%" height="4px" rounded="2px"></skeleton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton'

export default {
  name: 'SkeletonTeam',
  components: { Skeleton }
}
</script>
